(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-care-guide-instructions"] && !Shopify.designMode) return;
  try {
    
	if (!window.LTASCGInstructionsTabsInit) {
		window.LTASCGInstructionsTabsInit = true

		class LTASCGInstructionsTabs {
			constructor(rootEl) {
				this._rootEl = rootEl
				this._onTriggerClick = this._onTriggerClick.bind(this)
				this._onTriggerKeydown = this._onTriggerKeydown.bind(this)
				this._cleanups = []
			}

			connect() {
				this._tabTriggers = [...this._rootEl.querySelectorAll('[data-tab-trigger]')]
				this._tabPanels = [...this._rootEl.querySelectorAll('[data-tab-panel]')]

				if (!this._tabTriggers.length || !this._tabPanels.length) return

				this._tabTriggers.forEach((triggerEl) => {
					triggerEl.addEventListener('click', this._onTriggerClick)
					triggerEl.addEventListener('keydown', this._onTriggerKeydown)
					this._cleanups.push(() => triggerEl.removeEventListener('click', this._onTriggerClick))
					this._cleanups.push(() => triggerEl.removeEventListener('keydown', this._onTriggerKeydown))
				})
			}

			disconnect() {
				this._cleanups.forEach((cleanup) => cleanup())
				this._cleanups = []
			}

			_onTriggerClick(event) {
				this._activateTab(event.currentTarget)
			}

			_onTriggerKeydown(event) {
				const triggerEl = event.currentTarget
				const triggerIndex = this._tabTriggers.indexOf(triggerEl)

				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault()
					this._activateTab(triggerEl)
					return
				}

				if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
					event.preventDefault()
					const direction = event.key === 'ArrowRight' ? 1 : -1
					const nextIndex = (triggerIndex + direction + this._tabTriggers.length) % this._tabTriggers.length
					this._tabTriggers[nextIndex]?.focus()
				}
			}

			_activateTab(triggerEl) {
				if (triggerEl.classList.contains('is-active')) return

				const tabId = triggerEl.dataset.tabId
				const panelEl = this._rootEl.querySelector(`[data-tab-panel][data-tab-id="${tabId}"]`)

				if (!panelEl) return

				this._tabTriggers.forEach((el) => {
					const isActive = el === triggerEl
					el.classList.toggle('is-active', isActive)
					el.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this._tabPanels.forEach((el) => {
					const isActive = el === panelEl
					el.classList.toggle('is-active', isActive)
					el.toggleAttribute('hidden', !isActive)
				})
			}

			activateFromTrigger(triggerEl) {
				this._activateTab(triggerEl)
			}
		}

		const tabInstances = new WeakMap()

		const initTabs = (rootEl) => {
			if (tabInstances.has(rootEl)) return

			const instance = new LTASCGInstructionsTabs(rootEl)
			instance.connect()
			tabInstances.set(rootEl, instance)
		}

		document.querySelectorAll('[data-cg-instructions-tabs]').forEach(initTabs)

		if (window.Shopify?.designMode) {
			document.addEventListener('shopify:section:load', (event) => {
				event.target.querySelectorAll('[data-cg-instructions-tabs]').forEach(initTabs)
			})

			document.addEventListener('shopify:block:select', (event) => {
				const rootEl = event.target.closest('[data-cg-instructions-tabs]')
				if (!rootEl) return

				initTabs(rootEl)

				const triggerEl = event.target.closest('[data-tab-trigger]')
				if (!triggerEl) return

				tabInstances.get(rootEl)?.activateFromTrigger(triggerEl)

				triggerEl.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
					inline: 'nearest',
				})
			})
		}
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-content-blocks"] && !Shopify.designMode) return;
  try {
    
	class LTAScrollPin extends HTMLElement {
		constructor() {
			super()

			this._segments = []
			this._ready = false
			this._ticking = false
			this._paused = false

			this._onScroll = this._onScroll.bind(this)
			this._onResize = this._onResize.bind(this)
			this._onCarouselLoaded = this._onCarouselLoaded.bind(this)
			this._onBlockSelect = this._onBlockSelect.bind(this)
			this._onBlockDeselect = this._onBlockDeselect.bind(this)
		}

		connectedCallback() {
			this.contentEl = this.querySelector('[data-scroll-pin-content]')
			this.carouselEls = Array.from(this.querySelectorAll('[data-scroll-pin-carousel]'))
			this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
			this.pinMedia = window.matchMedia('(min-width: 768px)')

			if (!this.contentEl || !this.carouselEls.length) return

			if (window.Shopify?.designMode) {
				document.addEventListener('shopify:block:select', this._onBlockSelect)
				document.addEventListener('shopify:block:deselect', this._onBlockDeselect)
			}

			this.addEventListener('l:swiper:carousel:loaded', this._onCarouselLoaded)
			this._onCarouselLoaded()
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this._onScroll)
			window.removeEventListener('resize', this._onResize)
			this.pinMedia?.removeEventListener('change', this._onResize)
			this.removeEventListener('l:swiper:carousel:loaded', this._onCarouselLoaded)
			document.removeEventListener('shopify:block:select', this._onBlockSelect)
			document.removeEventListener('shopify:block:deselect', this._onBlockDeselect)
			this.resizeObserver?.disconnect()
			this.swipers?.forEach((swiper) => swiper?.off?.('resize', this._onResize))
			this.swipers = undefined
			this._ready = false
		}

		_onCarouselLoaded() {
			if (this._ready || !this.carouselEls.every((el) => el.swiperCarousel)) return
			this._ready = true
			this._setup()
		}

		_setup() {
			this.swipers = this.carouselEls.map((el) => el.swiperCarousel)
			this.swipers.forEach((swiper) => swiper.on('resize', this._onResize))

			window.addEventListener('scroll', this._onScroll, { passive: true })
			window.addEventListener('resize', this._onResize)
			this.pinMedia.addEventListener('change', this._onResize)

			if ('ResizeObserver' in window) {
				this.resizeObserver = new ResizeObserver(this._onResize)
				this.resizeObserver.observe(this.contentEl)
			}

			this._measure()
		}

		_measure() {
			if (!this._ready) return

			// Measure in normal flow
			this.classList.remove('is-fixed', 'is-shifted')
			this._segments = []

			const canPin = this.pinMedia.matches && !this.reducedMotion.matches
			const viewportHeight = window.innerHeight
			const contentRect = this.contentEl.getBoundingClientRect()
			let total = 0

			if (canPin) {
				this.carouselEls.forEach((el, index) => {
					const swiper = this.swipers[index]
					const distance = Math.max(0, swiper.minTranslate() - swiper.maxTranslate())
					if (distance <= 0) return

					// Center the carousel; when the content is taller than the viewport, never expose blank space.
					let pinTop = (viewportHeight - contentRect.height) / 2
					if (contentRect.height > viewportHeight) {
						const rect = el.getBoundingClientRect()
						const centered = viewportHeight / 2 - (rect.top - contentRect.top) - rect.height / 2
						pinTop = Math.min(0, Math.max(viewportHeight - contentRect.height, centered))
					}

					this._segments.push({ swiper, distance, pinTop, start: total - pinTop, progress: -1 })
					total += distance
				})
			}

			this.classList.toggle('is-pinned', this._segments.length > 0)

			if (!this._segments.length) {
				this.style.removeProperty('height')
				return
			}

			this.style.height = `${contentRect.height + total}px`
			this.style.setProperty('--l-pin-left', `${contentRect.left}px`)
			this.style.setProperty('--l-pin-width', `${contentRect.width}px`)

			this._update()
		}

		_onResize() {
			window.requestAnimationFrame(() => this._measure())
		}

		_onScroll() {
			if (this._ticking) return
			this._ticking = true

			window.requestAnimationFrame(() => {
				this._ticking = false
				this._update()
			})
		}

		_update() {
			if (!this._segments.length) return

			const scrolled = -this.getBoundingClientRect().top
			let shift = 0
			let active = null

			this._segments.forEach((segment) => {
				let progress = 0

				if (scrolled >= segment.start + segment.distance) {
					progress = 1
					shift += segment.distance
				} else if (scrolled >= segment.start) {
					progress = (scrolled - segment.start) / segment.distance
					active = segment
				}

				if (!this._paused && progress !== segment.progress) {
					segment.progress = progress
					segment.swiper.setProgress(progress, 0)
				}
			})

			this.classList.toggle('is-fixed', !!active)
			this.classList.toggle('is-shifted', !active && shift > 0)

			if (active) {
				this.style.setProperty('--l-pin-top', `${active.pinTop}px`)
			} else {
				this.style.setProperty('--l-pin-shift', `${shift}px`)
			}
		}

		_onBlockSelect(event) {
			if (this.carouselEls.some((el) => event.target?.contains(el))) this._paused = true
		}

		_onBlockDeselect(event) {
			if (!this.carouselEls.some((el) => event.target?.contains(el))) return
			this._paused = false
			this._segments.forEach((segment) => (segment.progress = -1))
			this._update()
		}
	}

	if (!customElements.get('l-scroll-pin')) {
		customElements.define('l-scroll-pin', LTAScrollPin)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-featured-collection"] && !Shopify.designMode) return;
  try {
    
	const l_featuredPlpQuickLinksCache = new Map()

	if (!customElements.get('l-featured-plp-quick-links')) {
		class LTAFeaturedPlpQuickLinks extends HTMLElement {
			constructor() {
				super()

				this.abortController = null
				this.sectionId = ''
				this.templateSuffix = ''
				this._activeRequestId = null
				this._onClick = this._onClick.bind(this)
				this._onPopState = this._onPopState.bind(this)
			}

			connectedCallback() {
				this.sectionId = this.dataset.sectionId || ''
				const sectionEl = this.sectionEl

				if (this.dataset.isPageTemplate === 'true' && sectionEl) {
					sectionEl.dataset.featuredPlpPageTemplate = 'true'
				}

				this.templateSuffix = this.dataset.templateSuffix || ''
				this.isPageTemplate = sectionEl?.dataset.featuredPlpPageTemplate === 'true'
				this.currentCollectionUrl =
					sectionEl?.dataset.featuredPlpCurrentCollectionUrl || this.dataset.currentCollectionUrl || ''

				if (this.isPageTemplate && sectionEl && this.currentCollectionUrl) {
					sectionEl.dataset.featuredPlpCurrentCollectionUrl = this.currentCollectionUrl
				}

				this._syncActiveLinks(this._getActiveCollectionUrl())
				this._cacheCurrentSection()
				this.addEventListener('click', this._onClick)

				if (!this.isPageTemplate) {
					window.addEventListener('popstate', this._onPopState)
				}
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick)
				window.removeEventListener('popstate', this._onPopState)
				this.abortController?.abort()
			}

			get sectionEl() {
				if (!this.sectionId) return null
				return document.getElementById(`shopify-section-${this.sectionId}`)
			}

			_getActiveCollectionUrl() {
				if (this.isPageTemplate) {
					return this.sectionEl?.dataset.featuredPlpCurrentCollectionUrl || this.currentCollectionUrl || ''
				}

				return window.location.href
			}

			_onClick(event) {
				const linkEl = event.target.closest('[data-quick-link]')
				if (!linkEl || !this.contains(linkEl)) return

				const href = linkEl.getAttribute('href')
				if (!href || href === '#') return
				if (!this._isCollectionUrl(href)) return

				event.preventDefault()

				const targetPath = this._normalizeCollectionPath(href)
				const currentPath = this._normalizeCollectionPath(this._getActiveCollectionUrl())

				if (targetPath && targetPath === currentPath) {
					this._syncActiveLinks(href)
					return
				}

				this._syncActiveLinks(href)

				const updateHistory = !this.isPageTemplate
				const historyUrl = this._buildHistoryUrl(href).toString()
				this._navigateToCollection(historyUrl, updateHistory, href)
			}

			_onPopState(event) {
				if (this.isPageTemplate) return
				if (event.state && !event.state.featuredPlpQuickLink) return
				if (!this._isCollectionUrl(window.location.href)) return

				this._navigateToCollection(this._buildHistoryUrl(window.location.href).toString(), false, window.location.href)
			}

			_isCollectionUrl(href) {
				try {
					const url = new URL(href, window.location.origin)
					if (url.origin !== window.location.origin) return false

					const segments = url.pathname.split('/').filter(Boolean)
					const collectionsIndex = segments.indexOf('collections')
					if (collectionsIndex === -1) return false
					if (!segments[collectionsIndex + 1]) return false
					if (segments.includes('products')) return false

					return true
				} catch {
					return false
				}
			}

			_buildHistoryUrl(href) {
				const url = new URL(href, window.location.origin)
				url.search = ''

				if (this.templateSuffix) {
					url.searchParams.set('view', this.templateSuffix)
				}

				return url
			}

			_buildFetchUrl(href) {
				const url = new URL(href, window.location.origin)
				url.search = ''

				if (!this.isPageTemplate && this.templateSuffix) {
					url.searchParams.set('view', this.templateSuffix)
				}

				if (this.sectionId) url.searchParams.set('section_id', this.sectionId)

				return url
			}

			_getCacheKey(href) {
				const collectionPath = this._normalizeCollectionPath(href)

				if (this.isPageTemplate) {
					return collectionPath
				}

				return this._buildHistoryUrl(href).toString()
			}

			_normalizeCollectionPath(href) {
				try {
					const url = new URL(href, window.location.origin)
					const path = url.pathname.replace(/\/+$/, '')
					return path || '/'
				} catch {
					return ''
				}
			}

			_syncActiveLinks(targetHref = this._getActiveCollectionUrl()) {
				const currentPath = this._normalizeCollectionPath(targetHref)

				this.querySelectorAll('[data-quick-link]').forEach((linkEl) => {
					const href = linkEl.getAttribute('href')
					if (!href || href === '#') {
						linkEl.classList.remove('is-active')
						return
					}

					const linkPath = this._normalizeCollectionPath(href)
					linkEl.classList.toggle('is-active', linkPath !== '' && linkPath === currentPath)
				})
			}

			_updateTitle(sectionEl, targetHref = '') {
				const titleEl = sectionEl?.querySelector('[data-featured-plp-title]')
				if (!titleEl) return

				const currentPath = this._normalizeCollectionPath(targetHref || this._getActiveCollectionUrl())
				if (!currentPath) return

				const matchingLinkEl = [...sectionEl.querySelectorAll('[data-quick-link]')].find((linkEl) => {
					const href = linkEl.getAttribute('href')
					if (!href || href === '#') return false

					return this._normalizeCollectionPath(href) === currentPath
				})

				const heading = matchingLinkEl?.dataset.heading?.trim()
				if (!heading) return

				titleEl.textContent = heading
			}

			_cacheCurrentSection() {
				const sectionEl = this.sectionEl
				if (!sectionEl) return

				const cacheKey = this._getCacheKey(this._getActiveCollectionUrl())
				l_featuredPlpQuickLinksCache.set(cacheKey, {
					sectionHTML: sectionEl.innerHTML,
				})
			}

			_navigateToCollection(historyUrl, updateHistory = true, fetchHref = historyUrl) {
				if (!this.sectionId || !this.sectionEl) {
					window.location.href = this.isPageTemplate ? fetchHref : historyUrl
					return
				}

				if (updateHistory) this._cacheCurrentSection()

				const cacheKey = this._getCacheKey(fetchHref)
				const cached = l_featuredPlpQuickLinksCache.get(cacheKey)

				if (cached) {
					this._renderCachedSection(cached, historyUrl, updateHistory, fetchHref)
					return
				}

				const requestId = Symbol('featured-plp-quick-link')
				this._activeRequestId = requestId
				this._showLoading()

				this.abortController?.abort()
				this.abortController = new AbortController()

				const fetchUrl = this._buildFetchUrl(fetchHref).toString()

				fetch(fetchUrl, { signal: this.abortController.signal })
					.then((response) => {
						if (!response.ok) throw new Error(`Failed to fetch collection: ${response.status}`)
						return response.text()
					})
					.then((html) => {
						if (this._activeRequestId !== requestId) return

						const pageData = this._parseSection(html)
						l_featuredPlpQuickLinksCache.set(cacheKey, pageData)

						if (updateHistory) {
							history.pushState({ featuredPlpQuickLink: true }, '', historyUrl)
						}

						this._applySection(pageData, fetchHref)
					})
					.catch((error) => {
						if (error.name === 'AbortError') return
						console.error('[LTAFeaturedPlpQuickLinks] Fetch error:', error)

						if (this.isPageTemplate) {
							window.location.href = fetchHref
							return
						}

						window.location.href = historyUrl
					})
					.finally(() => {
						if (this._activeRequestId === requestId) {
							this._hideLoading()
						}
					})
			}

			_renderCachedSection(pageData, historyUrl, updateHistory, fetchHref = historyUrl) {
				const requestId = Symbol('featured-plp-quick-link-cache')
				this._activeRequestId = requestId
				this._showLoading()

				window.setTimeout(() => {
					if (this._activeRequestId !== requestId) return

					try {
						if (updateHistory) {
							history.pushState({ featuredPlpQuickLink: true }, '', historyUrl)
						}

						this._applySection(pageData, fetchHref)
					} finally {
						this._hideLoading()
					}
				}, 400)
			}

			_showLoading() {
				document.documentElement.classList.add('is-featured-plp-loading')

				let overlay = document.querySelector('[data-featured-plp-loading]')
				if (overlay) return

				overlay = document.createElement('div')
				overlay.className = 'l-sFeaturedPLP__loading'
				overlay.setAttribute('data-featured-plp-loading', '')
				overlay.setAttribute('role', 'status')
				overlay.setAttribute('aria-live', 'polite')
				overlay.innerHTML = `
					<span class="l-sFeaturedPLP__loading-spinner" aria-hidden="true"></span>
					<span class="l-input-sr-only">Loading</span>
				`
				document.body.appendChild(overlay)
			}

			_hideLoading() {
				document.documentElement.classList.remove('is-featured-plp-loading')
				document.querySelector('[data-featured-plp-loading]')?.remove()
			}

			_parseSection(html) {
				const doc = new DOMParser().parseFromString(html, 'text/html')
				const newSection = doc.getElementById(`shopify-section-${this.sectionId}`) || doc.body?.firstElementChild

				if (!newSection) {
					throw new Error('Featured collection section not found')
				}

				newSection.querySelectorAll('script').forEach((script) => script.remove())

				return {
					sectionHTML: newSection.innerHTML,
				}
			}

			_applySection(pageData, fetchHref = '') {
				const sectionEl = this.sectionEl
				if (!sectionEl || !pageData?.sectionHTML) {
					throw new Error('Featured collection section not found')
				}

				if (fetchHref) {
					sectionEl.dataset.featuredPlpCurrentCollectionUrl = fetchHref
				}

				const quickLinksEl = sectionEl.querySelector('l-featured-plp-quick-links')
				const quickLinksOffset = quickLinksEl ? quickLinksEl.getBoundingClientRect().top : null

				const temp = document.createElement('div')
				temp.innerHTML = pageData.sectionHTML
				temp.querySelectorAll('.aos-animate').forEach((el) => el.classList.remove('aos-animate'))

				sectionEl.innerHTML = temp.innerHTML

				const nextQuickLinksEl = sectionEl.querySelector('l-featured-plp-quick-links')

				if (nextQuickLinksEl && fetchHref) {
					nextQuickLinksEl.dataset.currentCollectionUrl = fetchHref
				}

				this._updateTitle(sectionEl, fetchHref)

				sectionEl.querySelectorAll('img.is-loading').forEach((img) => {
					if (!img.complete) return
					img.classList.remove('is-loading')
					img.parentElement?.classList.remove('is-loading')
				})

				if (nextQuickLinksEl && quickLinksOffset !== null) {
					const offsetDiff = nextQuickLinksEl.getBoundingClientRect().top - quickLinksOffset
					if (offsetDiff !== 0) {
						window.scrollBy(0, offsetDiff)
					}
				}

				requestAnimationFrame(() => {
					sectionEl.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }))
				})
			}
		}

		customElements.define('l-featured-plp-quick-links', LTAFeaturedPlpQuickLinks)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-find-your-size"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-find-size-steps')) {
		class LTAFindSizeSteps extends HTMLElement {
			connectedCallback() {
				this.swiperEl = this.querySelector('[data-role="text-swiper"]')
				this.counterEl = this.querySelector('[data-step-counter]')
				this.prevBtn = this.querySelector('[data-step-prev]')
				this.nextBtn = this.querySelector('[data-step-next]')
				this.mediaItems = Array.from(this.querySelectorAll('[data-media-index]'))

				if (!this.swiperEl) return

				this._checkReady = this._checkReady.bind(this)
				this._checkReady()
			}

			_checkReady() {
				if (this.swiperEl.swiperCarousel) {
					this._wire()
					return
				}

				requestAnimationFrame(this._checkReady)
			}

			_wire() {
				const swiper = this.swiperEl.swiperCarousel

				this.prevBtn?.addEventListener('click', () => this.swiperEl.slideTo(swiper.activeIndex - 1))
				this.nextBtn?.addEventListener('click', () => this.swiperEl.slideTo(swiper.activeIndex + 1))

				swiper.on('slideChange', () => this._syncState(swiper.activeIndex))

				this._syncState(swiper.activeIndex)
			}

			_syncState(index) {
				const total = this.mediaItems.length

				this.mediaItems.forEach((item, itemIndex) => {
					item.classList.toggle('is-active', itemIndex === index)
				})

				if (this.counterEl) this.counterEl.textContent = `${index + 1} / ${total}`
				if (this.prevBtn) this.prevBtn.disabled = index <= 0
				if (this.nextBtn) this.nextBtn.disabled = index >= total - 1
			}
		}

		customElements.define('l-find-size-steps', LTAFindSizeSteps)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-fit-text"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-fit-text')) {
		class LTAFitText extends HTMLElement {
			connectedCallback() {
				this._cleanups = []
				this._barEl = this
				this._textEl = this.querySelector('[data-role="fit-text"]')
				this._onResize = this._onResize.bind(this)

				window.addEventListener('resize', this._onResize)
				this._cleanups.push(() => window.removeEventListener('resize', this._onResize))

				if (typeof ResizeObserver === 'function') {
					this._resizeObserver = new ResizeObserver(() => this._fitToWidth())
					this._resizeObserver.observe(this)
					this._cleanups.push(() => {
						this._resizeObserver?.disconnect()
						this._resizeObserver = null
					})
				}

				this._fitToWidth()
			}

			disconnectedCallback() {
				window.clearTimeout(this._resizeTimer)
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
			}

			_fitToWidth() {
				if (!this._textEl || !this._barEl) return

				const label = (this._textEl.textContent || '').trim()
				if (!label) return

				const barStyles = getComputedStyle(this._barEl)
				const padX = (parseFloat(barStyles.paddingLeft) || 0) + (parseFloat(barStyles.paddingRight) || 0)
				const available = Math.floor(this._barEl.clientWidth - padX)
				if (available <= 0) return

				this._textEl.style.letterSpacing = '0px'
				this._textEl.style.fontSize = ''
				this._textEl.style.width = 'max-content'
				this._textEl.style.maxWidth = 'none'
				this._textEl.style.whiteSpace = 'nowrap'

				/* Binary search a single-line size that fits the content box */
				let lo = 8
				let hi = Math.min(120, available)
				let best = lo

				for (let i = 0; i < 18; i += 1) {
					const mid = (lo + hi) / 2
					this._textEl.style.fontSize = `${mid}px`

					if (this._textEl.scrollWidth <= available) {
						best = mid
						lo = mid
					} else {
						hi = mid
					}
				}

				this._textEl.style.fontSize = `${best}px`

				if (this._textEl.scrollWidth > available) {
					const ratio = available / this._textEl.scrollWidth
					this._textEl.style.fontSize = `${Math.max(8, best * ratio)}px`
				}

				/* Spread remaining space across characters (CTA-bar feel) */
				const charCount = [...label].length
				const leftover = available - this._textEl.scrollWidth
				if (charCount > 1 && leftover > 1) {
					this._textEl.style.letterSpacing = `${leftover / (charCount - 1)}px`
				}

				this._textEl.style.width = '100%'
				this._textEl.style.maxWidth = '100%'
			}

			_onResize() {
				window.clearTimeout(this._resizeTimer)
				this._resizeTimer = window.setTimeout(() => this._fitToWidth(), 120)
			}

			_restart() {
				window.clearTimeout(this._resizeTimer)
				this._fitToWidth()
			}
		}

		customElements.define('l-fit-text', LTAFitText)

		document.addEventListener('shopify:section:load', (event) => {
			const fit = event.target.querySelector('l-fit-text')
			if (fit && typeof fit._restart === 'function') fit._restart()
		})
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-golden-laces-content"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-gl-content-video')) {
		class LTAGlContentVideo extends HTMLElement {
			constructor() {
				super()
				this._onPlayClick = this._onPlayClick.bind(this)
			}

			connectedCallback() {
				this._playButton = this.querySelector('[data-gl-video-play]')

				if (this._playButton) {
					this._playButton.addEventListener('click', this._onPlayClick)
				}
			}

			disconnectedCallback() {
				this._playButton?.removeEventListener('click', this._onPlayClick)
			}

			_onPlayClick(event) {
				event.preventDefault()

				const html = this._playButton?.getAttribute('data-gl-video-play')?.trim()
				if (!html || !window.theme?.LoadPhotoswipe) return

				if (window.theme.a11y?.state) {
					window.theme.a11y.state.trigger = this._playButton
				}

				new window.theme.LoadPhotoswipe([{ html }], {
					mainClass: 'pswp--video pswp--gl-content',
				})
			}
		}

		customElements.define('l-gl-content-video', LTAGlContentVideo)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-golden-laces-hero"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-gl-hero')) {
		class LTAGlHero extends HTMLElement {
			/* ----------------------------------------------------------
			 * Lifecycle
			 * ---------------------------------------------------------- */
			connectedCallback() {
				this._timers = []
				this._cleanups = []
				this._started = false
				this._stepMs = Number(this.dataset.stepMs) || 1200
				this._threshold = Number(this.dataset.threshold) || 0.35
				this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
				this._isVideo = this.classList.contains('is-media-video')

				this._bleedEl = this.querySelector('[data-role="bleed-media"]')
				this._inlineMedia = this.querySelector('[data-role="inline-media"]')
				this._headline = this.querySelector('[data-role="headline"]')
				this._ctaBar = this.querySelector('[data-role="cta-bar"]')
				this._ctaChars = this.querySelector('[data-role="cta-chars"]')
				this._expandMs = 1400
				this._inlineOpenMs = 900
				this._ctaSlideMs = 500
				this._introMs = Number(this.dataset.introMs) || 700

				this._onResize = this._onResize.bind(this)
				window.addEventListener('resize', this._onResize)
				this._cleanups.push(() => window.removeEventListener('resize', this._onResize))

				this._bleedReady = this._preloadBleed()
				this._splitHeadlineChars()
				this._splitCtaChars()
				this._fitCtaToWidth()

				if (this._reducedMotion) {
					this._setStep(4)
					this._bleedEl?.classList.add('is-expanded')
					this._revealHeadline(true)
					this._revealCta(true)
					this._clearHeaderState()
					return
				}

				this._setStep(1)

				/* Video: wait until bleed can play before starting the sequence. */
				if (this._isVideo) {
					Promise.resolve(this._bleedReady)
						.catch(() => {})
						.finally(() => this._observe())
					return
				}

				this._observe()
			}

			disconnectedCallback() {
				this._clearTimers()
				this._clearHeaderState()
				this._cleanups.forEach((fn) => fn())
				this._cleanups = []
				if (this._observer) {
					this._observer.disconnect()
					this._observer = null
				}
			}

			/* ----------------------------------------------------------
			 * Header / chat chrome
			 * ---------------------------------------------------------- */
			_showHeader() {
				document.body.classList.add('l-gl-hero-header-overlay')
			}

			_clearHeaderState() {
				document.body.classList.remove('l-gl-hero-header-overlay')
			}

			/* ----------------------------------------------------------
			 * Bleed preload
			 * ---------------------------------------------------------- */
			_playVideo(video) {
				if (!video) return Promise.resolve()
				video.muted = true
				video.defaultMuted = true
				video.playsInline = true
				const playResult = video.play()
				if (playResult && typeof playResult.then === 'function') {
					return playResult.catch(() => {})
				}
				return Promise.resolve()
			}

			_preloadBleed() {
				const video = this._bleedEl?.querySelector('video')
				if (video) {
					const markReady = () => {
						this._bleedEl?.classList.add('is-ready')
					}

					const finish = () => {
						markReady()
						return this._playVideo(video)
					}

					/* Keep decoding frames while the yellow stage plays. */
					video.preload = 'auto'

					if (video.readyState >= 4) {
						return finish()
					}

					return new Promise((resolve) => {
						let settled = false
						const done = () => {
							if (settled) return
							settled = true
							finish().finally(resolve)
						}

						/* Prefer a real buffer — don't treat the first frame as ready. */
						video.addEventListener('canplaythrough', done, { once: true })
						video.addEventListener(
							'canplay',
							() => {
								if (video.readyState >= 3) {
									window.setTimeout(done, 200)
								}
							},
							{ once: true }
						)
						video.addEventListener('error', done, { once: true })
						this._timers.push(window.setTimeout(done, 8000))

						this._playVideo(video)
					})
				}

				const img = this._bleedEl?.querySelector('img')
				if (!img) return Promise.resolve()

				const markReady = () => {
					this._bleedEl?.classList.add('is-ready')
				}

				const settle = () => {
					markReady()
					if (typeof img.decode !== 'function') return Promise.resolve()
					return img
						.decode()
						.then(markReady)
						.catch(() => {})
				}

				if (img.complete && img.naturalWidth > 0) {
					return settle()
				}

				return new Promise((resolve) => {
					const done = () => {
						settle().finally(resolve)
					}

					img.addEventListener('load', done, { once: true })
					img.addEventListener(
						'error',
						() => {
							markReady()
							resolve()
						},
						{ once: true }
					)
				})
			}

			/* ----------------------------------------------------------
			 * Headline — split chars + flip reveal
			 * ---------------------------------------------------------- */
			_splitHeadlineChars() {
				if (!this._headline) return

				this._headline.classList.remove('is-revealed')

				const words = this._headline.querySelectorAll('[data-role="headline-word"]')
				let charIndex = 0

				words.forEach((word) => {
					const label = (word.dataset.label || '').trim()
					word.replaceChildren()
					if (!label) return
					;[...label].forEach((char, index) => {
						const i = charIndex + index

						if (char === ' ') {
							const space = document.createElement('span')
							space.setAttribute('data-char-space', '')
							space.innerHTML = '&nbsp;'
							word.appendChild(space)
							return
						}

						const span = document.createElement('span')
						span.setAttribute('data-char', '')
						span.style.setProperty('--char-i', String(i))
						span.textContent = char
						word.appendChild(span)
					})

					charIndex += label.length
				})
			}

			_revealHeadline(immediate) {
				if (!this._headline) return

				if (immediate) {
					this._headline.classList.add('is-revealed')
					return
				}

				requestAnimationFrame(() => {
					this._headline.classList.add('is-revealed')
				})
			}

			/* ----------------------------------------------------------
			 * CTA — split chars + fit single-line width
			 * ---------------------------------------------------------- */
			_splitCtaChars() {
				if (!this._ctaChars) return

				const label = (this.dataset.ctaLabel || '').trim()
				this._ctaChars.replaceChildren()
				this._ctaChars.style.fontSize = ''

				if (!label) return
				;[...label].forEach((char, index) => {
					if (char === ' ') {
						const space = document.createElement('span')
						space.setAttribute('data-char-space', '')
						space.innerHTML = '&nbsp;'
						this._ctaChars.appendChild(space)
						return
					}

					const span = document.createElement('span')
					span.setAttribute('data-char', '')
					span.style.setProperty('--char-i', String(index))
					span.textContent = char
					this._ctaChars.appendChild(span)
				})
			}

			_fitCtaToWidth() {
				if (!this._ctaChars || !this._ctaBar) return

				const label = (this.dataset.ctaLabel || '').trim()
				if (!label) return

				const barStyles = getComputedStyle(this._ctaBar)
				const padX = (parseFloat(barStyles.paddingLeft) || 0) + (parseFloat(barStyles.paddingRight) || 0)
				const available = Math.floor(this._ctaBar.clientWidth - padX)
				if (available <= 0) return

				this._ctaChars.style.justifyContent = 'flex-start'
				this._ctaChars.style.letterSpacing = '0px'
				this._ctaChars.style.fontSize = ''
				this._ctaChars.style.flexWrap = 'nowrap'
				this._ctaChars.style.whiteSpace = 'nowrap'
				this._ctaChars.style.width = 'max-content'
				this._ctaChars.style.maxWidth = 'none'
				this._splitCtaChars()

				/* Binary search a single-line size that fits the content box */
				let lo = 8
				let hi = Math.min(120, available)
				let best = lo

				for (let i = 0; i < 18; i += 1) {
					const mid = (lo + hi) / 2
					this._ctaChars.style.fontSize = `${mid}px`

					if (this._ctaChars.scrollWidth <= available) {
						best = mid
						lo = mid
					} else {
						hi = mid
					}
				}

				this._ctaChars.style.fontSize = `${best}px`

				if (this._ctaChars.scrollWidth > available) {
					const ratio = available / this._ctaChars.scrollWidth
					this._ctaChars.style.fontSize = `${Math.max(8, best * ratio)}px`
				}

				this._ctaChars.style.width = '100%'
				this._ctaChars.style.maxWidth = '100%'
				this._ctaChars.style.justifyContent = 'space-between'
			}

			_onResize() {
				window.clearTimeout(this._resizeTimer)
				this._resizeTimer = window.setTimeout(() => {
					const wasRevealed = this._ctaChars?.classList.contains('is-revealed')
					this._fitCtaToWidth()
					if (wasRevealed) this._ctaChars.classList.add('is-revealed')
				}, 120)
			}

			_revealCta(immediate) {
				if (!this._ctaChars) return

				this._fitCtaToWidth()

				if (immediate) {
					this._ctaChars.classList.add('is-revealed')
					return
				}

				requestAnimationFrame(() => {
					this._ctaChars.classList.add('is-revealed')
				})
			}

			/* ----------------------------------------------------------
			 * Playback — observe → steps 1–4
			 * ---------------------------------------------------------- */
			_observe() {
				if (!('IntersectionObserver' in window)) {
					this._start()
					return
				}

				this._observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (!entry.isIntersecting || this._started) return
							this._started = true
							this._observer.disconnect()
							this._observer = null
							this._start()
						})
					},
					{ threshold: this._threshold }
				)

				this._observer.observe(this)
			}

			_start() {
				this.classList.add('is-playing')
				this._showHeader()
				this._setStep(1)
				this._fitCtaToWidth()

				/* Brief hold so the yellow stage is readable before type starts */
				this._timers.push(
					window.setTimeout(() => {
						this._revealHeadline(false)
						this._queueStep(2, this._stepMs)
					}, this._introMs)
				)
			}

			_queueStep(step, delay) {
				this._timers.push(
					setTimeout(() => {
						if (step === 3) {
							this._goToStep3()
							return
						}

						this._setStep(step)

						if (step === 2) {
							/* Zoom as soon as the inline image finishes opening */
							this._queueStep(3, this._inlineOpenMs)
							return
						}

						this._queueStep(step + 1, this._stepMs)
					}, delay)
				)
			}

			_setStep(step) {
				this.classList.remove('is-step-1', 'is-step-2', 'is-step-3', 'is-step-4')
				this.classList.add(`is-step-${step}`)

				if (step < 4 && this._ctaChars) {
					this._ctaChars.classList.remove('is-revealed')
				}

				/* Inline video only starts after bleed is buffered (shared cache). */
				if (step === 2) {
					const inlineVideo = this._inlineMedia?.querySelector('video')
					const bleedVideo = this._bleedEl?.querySelector('video')
					if (inlineVideo && bleedVideo && Number.isFinite(bleedVideo.currentTime)) {
						try {
							inlineVideo.currentTime = bleedVideo.currentTime
						} catch (_) {}
					}
					this._playVideo(inlineVideo)
				}
			}

			_goToStep3() {
				const advance = () => {
					this._expandBleedFromInline()
				}

				if (this._bleedEl?.classList.contains('is-ready')) {
					advance()
					return
				}

				Promise.resolve(this._bleedReady).then(advance).catch(advance)
			}

			/* ----------------------------------------------------------
			 * FLIP expand → pan + step-4 overlay
			 * ---------------------------------------------------------- */
			_finishWithPanAndOverlay() {
				if (this._bleedEl) {
					this._bleedEl.classList.remove('is-expanding')
					this._bleedEl.classList.add('is-expanded')
				}

				this._setStep(4)
				this._fitCtaToWidth()
				this.classList.add('is-complete')
				this.classList.remove('is-playing')

				/* CTA bar scrolls up on its own — keep the bleed image still */
				this._timers.push(
					window.setTimeout(
						() => {
							this._revealCta(false)
						},
						this._reducedMotion ? 0 : this._ctaSlideMs
					)
				)
			}

			_resetBleedTransform() {
				if (!this._bleedEl) return

				this._bleedEl.classList.remove('is-expanding', 'is-expanded')
				this._bleedEl.style.transition = 'none'
				this._bleedEl.style.transform = ''
				this._bleedEl.style.borderRadius = ''
				this._bleedEl.style.opacity = ''
			}

			_expandBleedFromInline() {
				const bleed = this._bleedEl
				const inline = this._inlineMedia
				const bleedVideo = bleed?.querySelector('video')
				const inlineVideo = inline?.querySelector('video')

				if (bleedVideo) {
					if (inlineVideo && Number.isFinite(inlineVideo.currentTime)) {
						try {
							bleedVideo.currentTime = inlineVideo.currentTime
						} catch (_) {}
					}
					this._playVideo(bleedVideo)
				}

				if (!bleed) {
					this._setStep(3)
					this._finishWithPanAndOverlay()
					return
				}

				if (!inline || this._reducedMotion) {
					bleed.classList.add('is-expanded')
					bleed.style.transform = 'none'
					bleed.style.opacity = '1'
					this._setStep(3)
					this._finishWithPanAndOverlay()
					return
				}

				const stageRect = this.getBoundingClientRect()
				const fromRect = inline.getBoundingClientRect()

				if (fromRect.width < 2 || fromRect.height < 2 || stageRect.width < 2) {
					bleed.classList.add('is-expanded')
					this._setStep(3)
					this._finishWithPanAndOverlay()
					return
				}

				const tx = fromRect.left - stageRect.left
				const ty = fromRect.top - stageRect.top
				const sx = fromRect.width / stageRect.width
				const sy = fromRect.height / stageRect.height
				const radius = getComputedStyle(inline).borderRadius || '0px'

				bleed.style.transition = 'none'
				bleed.style.transformOrigin = '0 0'
				bleed.style.borderRadius = radius
				bleed.style.opacity = '1'
				bleed.style.transform = `translate(${tx}px, ${ty}px) scale(${sx}, ${sy})`
				bleed.classList.add('is-expanding')
				inline.style.visibility = 'hidden'

				this._setStep(3)
				bleed.offsetWidth

				const duration = `${this._expandMs}ms`
				bleed.style.transition = [
					`transform ${duration} var(--l-gl-hero-expand-ease)`,
					`border-radius ${duration} var(--l-gl-hero-expand-ease)`,
				].join(', ')
				bleed.style.transform = 'translate(0px, 0px) scale(1, 1)'
				bleed.style.borderRadius = '0px'

				this._timers.push(
					window.setTimeout(() => {
						this._finishWithPanAndOverlay()
					}, this._expandMs)
				)
			}

			/* ----------------------------------------------------------
			 * Timers / editor reload
			 * ---------------------------------------------------------- */
			_clearTimers() {
				this._timers.forEach((id) => clearTimeout(id))
				this._timers = []
				window.clearTimeout(this._resizeTimer)
			}

			_restart() {
				this._clearTimers()
				this._started = false
				this.classList.remove('is-playing', 'is-complete')
				this._resetBleedTransform()
				if (this._inlineMedia) {
					this._inlineMedia.style.opacity = ''
					this._inlineMedia.style.visibility = ''
				}
				this._bleedReady = this._preloadBleed()
				this._splitHeadlineChars()
				this._splitCtaChars()
				this._fitCtaToWidth()

				if (this._reducedMotion) {
					this._setStep(4)
					this._bleedEl?.classList.add('is-expanded')
					this._revealHeadline(true)
					this._revealCta(true)
					this._clearHeaderState()
					return
				}

				this._setStep(1)
				this._clearHeaderState()
				if (this._observer) this._observer.disconnect()

				if (this._isVideo) {
					Promise.resolve(this._bleedReady)
						.catch(() => {})
						.finally(() => this._observe())
					return
				}

				this._observe()
			}
		}

		customElements.define('l-gl-hero', LTAGlHero)

		document.addEventListener('shopify:section:load', (event) => {
			const hero = event.target.querySelector('l-gl-hero')
			if (hero && typeof hero._restart === 'function') hero._restart()
		})
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-golden-laces-newsletter"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-sg-news-form')) {
		class LTASgNewsForm extends HTMLElement {
			connectedCallback() {
				if (this._setup) return
				this._setup = true
				this._form = this.querySelector('form')
				this._fields = this.querySelector('[data-form-fields]')
				this._status = this.querySelector('[data-form-status]')
				this._submit = this.querySelector('[type="submit"]')
				this._onSubmit = this._onSubmit.bind(this)
				this._form?.addEventListener('submit', this._onSubmit)
			}

			disconnectedCallback() {
				this._form?.removeEventListener('submit', this._onSubmit)
			}

			async _onSubmit(event) {
				event.preventDefault()
				if (this._busy) return

				const emailInput = this._form?.querySelector('input[type="email"]')
				const email = (emailInput?.value || '').trim()
				const companyId = this.getAttribute('data-company-id')
				const listId = this.getAttribute('data-list-id')

				if (!emailInput || !email || !emailInput.checkValidity()) {
					emailInput?.reportValidity()
					this._showStatus(this.getAttribute('data-error-msg'), true)
					return
				}

				if (!companyId || !listId) {
					this._showStatus(this.getAttribute('data-error-msg'), true)
					return
				}

				this._busy = true
				if (this._submit) this._submit.disabled = true
				this._showStatus('', false)

				try {
					const body = new URLSearchParams()
					body.append('g', listId)
					body.append('email', email)

					const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
						},
						body: body.toString(),
					})

					const result = await response.json().catch(() => null)
					const success = Boolean(
						response.ok && result && (result.success === true || result.success?.success === true)
					)

					if (!success) {
						throw new Error('klaviyo_subscribe_failed')
					}

					this._onSuccess()
				} catch (error) {
					this._busy = false
					if (this._submit) this._submit.disabled = false
					this._showStatus(this.getAttribute('data-error-msg'), true)
				}
			}

			_showStatus(message, isError) {
				if (!this._status) return
				if (!message) {
					this._status.hidden = true
					this._status.textContent = ''
					this._status.removeAttribute('role')
					return
				}
				this._status.hidden = false
				this._status.textContent = message
				this._status.setAttribute('role', isError ? 'alert' : 'status')
			}

			_onSuccess() {
				document.querySelectorAll('l-sg-news-form').forEach((form) => {
					if (typeof form._applySuccess === 'function') form._applySuccess()
				})
			}

			_applySuccess() {
				this._busy = true
				if (this._submit) this._submit.disabled = true

				const successMsg = this.getAttribute('data-success-msg') || ''
				if (this._fields) this._fields.hidden = true
				this._showStatus(successMsg, false)

				const container = this.closest('.l-sGNews-container')
				container?.classList.add('is-success')

				const rainSrc = this.getAttribute('data-rain-src')
				const section = this.closest('.shopify-section')
				if (!rainSrc || !section || section.querySelector('l-sg-news-rain')) return

				const wrap = document.createElement('div')
				wrap.className = 'l-sGNews-success-bg'
				wrap.setAttribute('aria-hidden', 'true')

				const rain = document.createElement('l-sg-news-rain')
				rain.className = 'l-sGNews-rain'
				rain.setAttribute('data-src', rainSrc)
				rain.setAttribute('aria-hidden', 'true')
				wrap.appendChild(rain)

				section.insertBefore(wrap, section.firstChild)
			}
		}

		customElements.define('l-sg-news-form', LTASgNewsForm)
	}

	if (!customElements.get('l-sg-news-rain')) {
		class LTASgNewsRain extends HTMLElement {
			connectedCallback() {
				this._src = this.getAttribute('data-src')
				if (!this._src || this._setup) return
				this._setup = true
				this._played = false
				this._onIntersect = this._onIntersect.bind(this)

				this._section = this.closest('.shopify-section') || this
				this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

				if (!('IntersectionObserver' in window)) {
					this._play()
					return
				}

				this._observer = new IntersectionObserver(this._onIntersect, {
					root: null,
					threshold: 0.2,
					rootMargin: '0px',
				})
				this._observer.observe(this._section)
			}

			disconnectedCallback() {
				this._observer?.disconnect()
				this._observer = null
			}

			_onIntersect(entries) {
				const entry = entries[0]
				if (!entry?.isIntersecting || this._played) return
				this._observer?.disconnect()
				this._observer = null
				this._play()
			}

			_play() {
				if (this._played) return
				this._played = true
				requestAnimationFrame(() => {
					this._build(this._src)
					requestAnimationFrame(() => {
						this.classList.add('is-ready')
					})
				})
			}

			_build(src) {
				const reduced = this._reducedMotion
				const sectionEl = this._section || this
				const container = sectionEl.querySelector('.l-sGNews-container')
				const sectionRect = sectionEl.getBoundingClientRect()
				const containerRect = container?.getBoundingClientRect()
				const viewW = Math.max(sectionRect.width || 0, sectionEl.clientWidth || 0, 1)
				const viewH = Math.max(sectionRect.height || 0, sectionEl.clientHeight || 0, containerRect?.height || 0, 1)
				const isMobile = window.innerWidth < 768
				const imgX = isMobile ? 50 : 100
				const imgY = isMobile ? 33 : 66
				const gap = isMobile ? 14 : 24
				const tileX = imgX + gap
				const tileY = imgY + gap
				const cols = Math.ceil(viewW / tileX) + 2
				const rows = Math.ceil(viewH / tileY) + 2
				const frag = document.createDocumentFragment()

				for (let c = 0; c < cols; c++) {
					for (let r = 0; r < rows; r++) {
						const img = document.createElement('img')
						img.src = src
						img.alt = ''
						img.decoding = 'async'
						img.setAttribute('data-rain-item', '')
						img.setAttribute('data-rain-col', String(c))
						img.setAttribute('data-rain-row', String(r))

						const offsetX = r % 2 === 0 ? 0 : tileX / 2
						const x = c * tileX + offsetX - tileX
						const y = r * tileY
						const delay = reduced ? 0 : c * 0.035 + r * 0.05 + ((c + r) % 4) * 0.02
						const dur = reduced ? 0 : 0.95 + ((c + r) % 5) * 0.06

						img.style.setProperty('--l-x', x.toFixed(1) + 'px')
						img.style.setProperty('--l-y', y.toFixed(1) + 'px')
						img.style.setProperty('--l-size', imgX + 'px')
						img.style.setProperty('--l-delay', delay.toFixed(2) + 's')
						img.style.setProperty('--l-dur', dur.toFixed(2) + 's')

						frag.appendChild(img)
					}
				}

				this.appendChild(frag)
			}
		}

		customElements.define('l-sg-news-rain', LTASgNewsRain)
	}

	if (!customElements.get('l-sg-news-tr')) {
		class LTASgNewsTr extends HTMLElement {
			constructor() {
				super()
				this._onScroll = this._onScroll.bind(this)
				this._onResize = this._onResize.bind(this)
				this._onIntersect = this._onIntersect.bind(this)
				this._raf = 0
				this._items = []
				this._section = null
				this._isV1 = false
				this._reducedMotion = false
				this._desktopMq = null
				this._mobileMq = null
				this._observer = null
				this._inView = false
				this._listening = false
			}

			connectedCallback() {
				this._section = this.closest('.shopify-section') || this.parentElement
				this._isV1 = Boolean(this.closest('.is-v1'))
				this._items = Array.from((this._section || this).querySelectorAll('[data-tr-item]'))
				if (!this._items.length) return

				this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
				this._desktopMq = window.matchMedia('(min-width: 1200px)')
				this._mobileMq = window.matchMedia('(max-width: 767px)')
				this._desktopMq.addEventListener('change', this._onResize)
				this._mobileMq.addEventListener('change', this._onResize)

				if (this._reducedMotion) {
					this._reset()
					return
				}

				this._setupObserver()
				this._syncMode()
			}

			/* v1: all viewports (rotate/scale on stack). v2: desktop corner pin only */
			_canAnimate() {
				if (this._reducedMotion) return false
				if (this._isV1) return true
				return Boolean(this._desktopMq?.matches)
			}

			disconnectedCallback() {
				this._teardownObserver()
				this._unbindScroll()
				this._desktopMq?.removeEventListener('change', this._onResize)
				this._mobileMq?.removeEventListener('change', this._onResize)
				if (this._raf) cancelAnimationFrame(this._raf)
			}

			_setupObserver() {
				if (!this._section || !('IntersectionObserver' in window)) {
					this._inView = true
					return
				}

				this._observer = new IntersectionObserver(this._onIntersect, {
					root: null,
					threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 1],
				})
				this._observer.observe(this._section)
			}

			_teardownObserver() {
				this._observer?.disconnect()
				this._observer = null
			}

			_onIntersect(entries) {
				const entry = entries[0]
				this._inView = Boolean(entry?.isIntersecting)
				if (this._inView) {
					this._bindScroll()
					this._onScroll()
				} else {
					this._unbindScroll()
					this._applyProgress(this._phaseProgress())
				}
			}

			_syncMode() {
				if (!this._canAnimate()) {
					this._unbindScroll()
					this._reset()
					return
				}
				if (this._inView || !this._observer) {
					this._bindScroll()
					this._onScroll()
				}
			}

			_bindScroll() {
				if (this._listening || !this._canAnimate()) return
				window.addEventListener('scroll', this._onScroll, { passive: true })
				window.addEventListener('resize', this._onResize, { passive: true })
				this._listening = true
			}

			_unbindScroll() {
				if (!this._listening) return
				window.removeEventListener('scroll', this._onScroll)
				window.removeEventListener('resize', this._onResize)
				this._listening = false
			}

			_onResize() {
				this._syncMode()
			}

			_onScroll() {
				if (this._raf) return
				this._raf = requestAnimationFrame(() => {
					this._raf = 0
					this._update()
				})
			}

			/*
			 * Phase 1 (settle): bottom → original (~0.7vh of scroll)
			 * Phase 2 (scroll): keep moving upward + slower rotate while section stays in view
			 */
			_phaseProgress() {
				if (!this._section) return { settle: 0, scroll: 0 }
				const rect = this._section.getBoundingClientRect()
				const view = window.innerHeight || 1
				const start = view
				const settleTravel = view * 0.7
				const settleEndTop = start - settleTravel
				const settle = this._clampProgress((start - rect.top) / settleTravel)

				const scrollTravel = Math.max(view * 1.4, rect.height * 0.65)
				const scroll = this._clampProgress((settleEndTop - rect.top) / scrollTravel)

				return { settle, scroll }
			}

			_clampProgress(p) {
				return Math.min(1, Math.max(0, p))
			}

			/*
			 * Per-item settle remap.
			 * - data-settle-anchor="bottom": drive by section bottom vs viewport.
			 *   data-settle-start / data-settle-end are viewport fractions (1 = bottom, 0.5 = middle).
			 * - else data-settle-delay / data-settle-duration on settle+scroll timeline.
			 */
			_itemSettle(item, settle, scroll) {
				const anchor = item.getAttribute('data-settle-anchor')
				if (anchor === 'bottom' && this._section) {
					const view = window.innerHeight || 1
					const startFrac = parseFloat(item.getAttribute('data-settle-start'))
					const endFrac = parseFloat(item.getAttribute('data-settle-end'))
					const startY = view * (Number.isNaN(startFrac) ? 1 : startFrac)
					const endY = view * (Number.isNaN(endFrac) ? 0.5 : endFrac)
					const travel = startY - endY
					if (travel <= 0) return 1
					const bottom = this._section.getBoundingClientRect().bottom
					return this._clampProgress((startY - bottom) / travel)
				}

				const delay = parseFloat(item.getAttribute('data-settle-delay'))
				const duration = parseFloat(item.getAttribute('data-settle-duration'))
				if (Number.isNaN(delay) && Number.isNaN(duration)) return settle

				const d = Number.isNaN(delay) ? 0 : delay
				const dur = Number.isNaN(duration) ? 1 : Math.max(0.01, duration)
				const continuous = settle + scroll
				return this._clampProgress((continuous - d) / dur)
			}

			_update() {
				if (!this._canAnimate()) {
					this._reset()
					return
				}
				if (!this._inView && this._observer) return
				this._applyProgress(this._phaseProgress())
			}

			_applyProgress({ settle, scroll }) {
				/* Stack v1: rotate (+ prospector Y on mobile). No scale on mobile. */
				const isStack = this._isV1 && !this._desktopMq.matches
				const isMobile = Boolean(this._mobileMq?.matches)

				this._items.forEach((item) => {
					const itemSettle = this._itemSettle(item, settle, scroll)
					const allowY = !isStack || (isMobile && item.classList.contains('l-sGNews-prospector'))

					let x = '0px'
					let y = '0px'
					if (!isStack) {
						x = this._lerpUnit(
							item.getAttribute('data-x-from') || '0',
							item.getAttribute('data-x-to') || '0',
							itemSettle
						)
					}

					if (allowY) {
						if (isMobile && item.classList.contains('l-sGNews-prospector')) {
							/* From layout position → up (no “start below” settle like desktop) */
							const yTo = item.getAttribute('data-y-scroll-mobile') || '-6vh'
							y = this._lerpUnit('0', yTo, itemSettle)
						} else {
							const yRest = this._lerpUnit(
								item.getAttribute('data-y-from') || '0',
								item.getAttribute('data-y-to') || '0',
								itemSettle
							)
							const yScroll = this._lerpUnit(
								item.getAttribute('data-y-to') || '0',
								item.getAttribute('data-y-scroll') || item.getAttribute('data-y-to') || '0',
								scroll
							)
							y = itemSettle < 1 ? yRest : yScroll
						}
					}

					const rotFrom = parseFloat(item.getAttribute('data-rot-from')) || 0
					const rotTo = parseFloat(item.getAttribute('data-rot-to')) || 0
					const rotScrollExtra = parseFloat(item.getAttribute('data-rot-scroll')) || 0
					const rotEase = parseFloat(item.getAttribute('data-rot-ease')) || 1
					const rotSettleP = rotEase === 1 ? itemSettle : Math.min(1, Math.pow(itemSettle, 1 / rotEase))
					const rotSettle = rotFrom + (rotTo - rotFrom) * rotSettleP
					const rot = itemSettle < 1 ? rotSettle : rotTo + rotScrollExtra * scroll
					const rotStr = rot.toFixed(2) + 'deg'

					const scaleFrom = parseFloat(item.getAttribute('data-scale-from'))
					const scaleTo = parseFloat(item.getAttribute('data-scale-to'))
					const scaleMin = parseFloat(item.getAttribute('data-scale-min'))
					const scaleMax = parseFloat(item.getAttribute('data-scale-max'))
					const hasScale = !isMobile && !Number.isNaN(scaleFrom) && !Number.isNaN(scaleTo)
					let scale = 1
					if (hasScale) {
						if (itemSettle < 1) {
							scale = scaleFrom + (scaleTo - scaleFrom) * itemSettle
						} else {
							const min = Number.isNaN(scaleMin) ? 0.8 : scaleMin
							const max = Number.isNaN(scaleMax) ? 1 : scaleMax
							const mid = (min + max) / 2
							const amp = (max - min) / 2
							/* Start at max (1) when scroll=0, then pulse min↔max */
							scale = mid + amp * Math.cos(scroll * Math.PI * 2)
						}
					}
					const scaleStr = scale.toFixed(3)

					item.style.setProperty('--l-tx', x)
					item.style.setProperty('--l-ty', y)
					item.style.setProperty('--l-rot', rotStr)
					item.style.setProperty('--l-scale', scaleStr)
					if (isStack) {
						item.style.transform = allowY
							? 'translate3d(0, ' + y + ', 0) rotate(' + rotStr + ')'
							: 'rotate(' + rotStr + ')'
					} else {
						item.style.transform = 'translate3d(' + x + ', ' + y + ', 0) rotate(' + rotStr + ') scale(' + scaleStr + ')'
					}
				})
			}

			_lerpUnit(fromValue, toValue, p) {
				const parse = (value) => {
					const match = String(value)
						.trim()
						.match(/^(-?[\d.]+)(.*)$/)
					if (!match) return { n: 0, u: '' }
					return { n: parseFloat(match[1]) || 0, u: match[2] || '' }
				}
				const from = parse(fromValue)
				const to = parse(toValue)
				const unit = to.u || from.u || ''
				return (from.n + (to.n - from.n) * p).toFixed(2) + unit
			}

			_reset() {
				this._items.forEach((item) => {
					item.style.removeProperty('--l-tx')
					item.style.removeProperty('--l-ty')
					item.style.removeProperty('--l-rot')
					item.style.removeProperty('--l-scale')
					item.style.removeProperty('transform')
				})
			}
		}

		customElements.define('l-sg-news-tr', LTASgNewsTr)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-hp-best-loved-gear"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-best-loved-gear-tabs')) {
		class LTABestLovedGearTabs extends HTMLElement {
			constructor() {
				super()
				this._onTriggerClick = this._onTriggerClick.bind(this)
				this._onTriggerKeydown = this._onTriggerKeydown.bind(this)
				this._onBlockSelect = this._onBlockSelect.bind(this)
				this._cleanups = []
			}

			connectedCallback() {
				this._rootEl = this.closest('[data-best-loved-gear-root]')
				this._tabListEl = this.querySelector('[data-tab-list]')
				this._tabTriggers = [...this.querySelectorAll('[data-tab-trigger]')]
				this._tabPanels = [...this.querySelectorAll('[data-tab-panel]')]

				if (!this._tabTriggers.length || !this._tabPanels.length) return

				this._tabTriggers.forEach((triggerEl) => {
					triggerEl.addEventListener('click', this._onTriggerClick)
					triggerEl.addEventListener('keydown', this._onTriggerKeydown)
					this._cleanups.push(() => triggerEl.removeEventListener('click', this._onTriggerClick))
					this._cleanups.push(() => triggerEl.removeEventListener('keydown', this._onTriggerKeydown))
				})

				if (window.Shopify?.designMode) {
					document.addEventListener('shopify:block:select', this._onBlockSelect)
					this._cleanups.push(() => document.removeEventListener('shopify:block:select', this._onBlockSelect))
				}
			}

			disconnectedCallback() {
				this._cleanups.forEach((cleanup) => cleanup())
				this._cleanups = []
			}

			_onTriggerClick(event) {
				const triggerEl = event.currentTarget
				this._activateTab(triggerEl)
			}

			_onTriggerKeydown(event) {
				const triggerEl = event.currentTarget
				const triggerIndex = this._tabTriggers.indexOf(triggerEl)

				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault()
					this._activateTab(triggerEl)
					return
				}

				if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
					event.preventDefault()
					const direction = event.key === 'ArrowRight' ? 1 : -1
					const nextIndex = (triggerIndex + direction + this._tabTriggers.length) % this._tabTriggers.length
					this._tabTriggers[nextIndex]?.focus()
				}
			}

			_onBlockSelect(event) {
				if (!this.contains(event.target)) return

				const triggerEl = event.target.closest('[data-tab-trigger]')
				if (!triggerEl) return

				this._activateTab(triggerEl)

				triggerEl.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
					inline: 'nearest',
				})
			}

			_activateTab(triggerEl) {
				if (triggerEl.classList.contains('is-active')) return

				const tabId = triggerEl.dataset.tabId
				const panelEl = this.querySelector(`[data-tab-panel][data-tab-id="${tabId}"]`)

				if (!panelEl) return

				this._tabTriggers.forEach((el) => {
					const isActive = el === triggerEl
					el.classList.toggle('is-active', isActive)
					el.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this._tabPanels.forEach((el) => {
					const isActive = el === panelEl
					el.classList.toggle('is-active', isActive)
					el.toggleAttribute('hidden', !isActive)
				})

				const collectionUrl = triggerEl.dataset.collectionUrl
				if (collectionUrl && this._rootEl) {
					const openInNewTab = triggerEl.dataset.openInNewTab === 'true'
					this._rootEl.querySelectorAll('[data-best-loved-gear-cta]').forEach((ctaEl) => {
						ctaEl.href = collectionUrl
						if (openInNewTab) {
							ctaEl.setAttribute('target', '_blank')
							ctaEl.setAttribute('rel', 'noopener noreferrer')
						} else {
							ctaEl.removeAttribute('target')
							ctaEl.removeAttribute('rel')
						}
					})
				}

				requestAnimationFrame(() => {
					panelEl.querySelector('l-swiper-carousel')?.swiperCarousel?.update()
				})
			}
		}

		customElements.define('l-best-loved-gear-tabs', LTABestLovedGearTabs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-product-recommendations"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-recommendations')) {
		class LTAProductRecommendations extends HTMLElement {
			connectedCallback() {
				// Skip instances created while parsing fetch HTML (DOMParser connects them)
				if (this.ownerDocument !== document) return
				if (this.querySelector('[data-recommendations]')) return
				if (!this.dataset.url) return

				this._observer = new IntersectionObserver(
					(entries, observer) => {
						if (!entries[0]?.isIntersecting) return

						observer.unobserve(this)
						this._loadRecommendations()
					},
					// Start fetching ~2 sections before this block enters the viewport
					{ rootMargin: '0px 0px 700px 0px' }
				)

				this._observer.observe(this)
			}

			disconnectedCallback() {
				this._observer?.disconnect()
			}

			_loadRecommendations() {
				if (this._loadStarted) return

				this._loadStarted = true

				fetch(this.dataset.url, { priority: 'low' })
					.then((response) => {
						if (!response.ok) throw new Error(response.status)
						return response.text()
					})
					.then((html) => {
						// Use a disconnected node so nested custom elements are not upgraded/connected
						const temp = document.createElement('div')
						temp.innerHTML = html

						const nextEl = temp.querySelector('l-product-recommendations')
						const hasProducts = Boolean(temp?.querySelector('[data-recommendations]'))

						if (!hasProducts) {
							this.closest('.shopify-section')?.classList.add('l-hidden')
							return
						}

						this.innerHTML = nextEl.innerHTML
					})
					.catch((error) => {
						console.error('[LTAProductRecommendations]', error)
						this.closest('.shopify-section')?.classList.add('l-hidden')
					})
			}
		}

		customElements.define('l-product-recommendations', LTAProductRecommendations)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-product-size-guide"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-size-guide')) {
		class LTAProductSizeGuide extends HTMLElement {
			constructor() {
				super()
				this.onClick = this.onClick.bind(this)
			}

			connectedCallback() {
				this.tabTriggers = Array.from(this.querySelectorAll('[data-tab-trigger]'))
				this.tabPanels = Array.from(this.querySelectorAll('[data-tab-panel]'))

				this.addEventListener('click', this.onClick)
				this.selectTab(this.dataset.defaultTab || this.tabTriggers[0]?.dataset.tabTrigger)
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.onClick)
			}

			onClick(event) {
				const tabTrigger = event.target.closest('[data-tab-trigger]')
				if (tabTrigger) {
					this.selectTab(tabTrigger.dataset.tabTrigger)
					return
				}

				const unitTrigger = event.target.closest('[data-unit-toggle]')
				if (unitTrigger) {
					this.setUnit(unitTrigger)
				}
			}

			selectTab(tabKey) {
				if (!tabKey) return

				this.tabTriggers.forEach((trigger) => {
					const isActive = trigger.dataset.tabTrigger === tabKey
					trigger.classList.toggle('is-active', isActive)
					trigger.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this.tabPanels.forEach((panel) => {
					panel.hidden = panel.dataset.tabPanel !== tabKey
				})
			}

			setUnit(trigger) {
				const row = trigger.closest('[data-active-unit]')
				if (!row) return

				row.setAttribute('data-active-unit', trigger.dataset.unitToggle)

				row.querySelectorAll('[data-unit-toggle]').forEach((button) => {
					button.classList.toggle('is-active', button === trigger)
				})
			}
		}

		customElements.define('l-product-size-guide', LTAProductSizeGuide)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-size-table"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-size-table')) {
		class LTASizeTable extends HTMLElement {
			constructor() {
				super()
				this._onClick = this._onClick.bind(this)
			}

			connectedCallback() {
				this.addEventListener('click', this._onClick)
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick)
			}

			_onClick(event) {
				const unitTrigger = event.target.closest('[data-unit-toggle]')
				if (unitTrigger) {
					this._setUnit(unitTrigger)
					return
				}

				const printTrigger = event.target.closest('[data-print-outline]')
				if (printTrigger) {
					event.preventDefault()
					this._printOutline(printTrigger)
				}
			}

			_setUnit(trigger) {
				const row = trigger.closest('[data-active-unit]')
				if (!row) return

				row.setAttribute('data-active-unit', trigger.dataset.unitToggle)

				row.querySelectorAll('[data-unit-toggle]').forEach((button) => {
					button.classList.toggle('is-active', button === trigger)
				})
			}

			_printOutline(trigger) {
				const src = trigger.dataset.printOutline
				if (!src) return

				const printWindow = window.open('', '_blank', 'noopener')
				if (!printWindow) return

				const label = trigger.dataset.printLabel || ''
				const doc = printWindow.document

				doc.title = label
				doc.body.style.margin = '0'

				const img = doc.createElement('img')
				img.src = src
				img.alt = label
				img.style.width = '100%'
				img.addEventListener('load', () => printWindow.print())

				doc.body.appendChild(img)
			}
		}

		customElements.define('l-size-table', LTASizeTable)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-sub-collections"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-sub-collections')) {
		class LTASubCollections extends HTMLElement {
			constructor() {
				super()
				this._onClick = this._onClick.bind(this)
			}

			connectedCallback() {
				this.filterButtons = this.querySelectorAll('[data-filter]')
				this.groups = this.querySelectorAll('[data-group]')
				this.addEventListener('click', this._onClick)

				if (typeof l_setPdpPrevCollectionPage === 'function') {
					l_setPdpPrevCollectionPage(this.dataset.pdpReturnTitle || '')
				}
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick)
			}

			_onClick(event) {
				const trigger = event.target.closest('[data-filter]')
				if (!trigger || !this.contains(trigger)) return

				this._setFilter(trigger.dataset.filter, trigger)
			}

			_setFilter(filter, activeTrigger) {
				this.filterButtons.forEach((button) => {
					const isActive = button === activeTrigger
					button.classList.toggle('is-active', isActive)
					button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
				})

				this.groups.forEach((group) => {
					const isMatch = filter === 'all' || group.dataset.group === filter
					group.classList.toggle('l-hidden', !isMatch)
				})

				if (filter === 'all') return

				requestAnimationFrame(() => {
					const target = this.querySelector(`[data-group="${CSS.escape(filter)}"]`)
					if (!target) return

					const fitsScreen = target.getBoundingClientRect().height <= window.innerHeight
					target.scrollIntoView({
						behavior: 'smooth',
						block: fitsScreen ? 'center' : 'start',
					})
				})
			}
		}

		customElements.define('l-sub-collections', LTASubCollections)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
	if (!customElements.get('l-pdp-breadcrumb')) {
		class LTAPdpBreadcrumb extends HTMLElement {
			connectedCallback() {
				this.linkEl = this.querySelector('[data-pdp-breadcrumb-link]')
				this.sepEl = this.querySelector('[data-pdp-breadcrumb-sep]')
				if (!this.linkEl) return

				this._resolve()
			}

			_resolve() {
				const collectionUrl = this.linkEl.dataset.collectionUrl || ''
				const collectionTitle = this.linkEl.dataset.collectionTitle || ''
				const typeUrl = this.linkEl.dataset.typeUrl || ''
				const typeTitle = this.linkEl.dataset.typeTitle || ''

				const collectionPath = typeof l_normalizePathname === 'function' ? l_normalizePathname(collectionUrl) : collectionUrl
				const prevFromStorage = typeof l_getPdpPrevCollectionPage === 'function' ? l_getPdpPrevCollectionPage() : null

				let prevUrl = ''
				let prevTitle = ''

				try {
					if (document.referrer) {
						const referrer = new URL(document.referrer)
						if (
							referrer.origin === window.location.origin &&
							typeof l_isCollectionPagePath === 'function' &&
							l_isCollectionPagePath(referrer.pathname)
						) {
							prevUrl = `${referrer.pathname}${referrer.search}`
							const referrerPath = l_normalizePathname(referrer.pathname)
							if (prevFromStorage && l_normalizePathname(prevFromStorage.url) === referrerPath) {
								prevTitle = prevFromStorage.title || ''
							}
						}
					}
				} catch (error) {
					/* ignore invalid referrer */
				}

				const prevPath = typeof l_normalizePathname === 'function' ? l_normalizePathname(prevUrl) : prevUrl

				let href = ''
				let title = ''

				if (prevUrl && prevPath && prevPath !== collectionPath) {
					href = prevUrl
					title = prevTitle || prevPath.split('/').pop().replace(/-/g, ' ')
				} else if (collectionUrl) {
					href = collectionUrl
					title = collectionTitle
				} else if (typeUrl) {
					href = typeUrl
					title = typeTitle
				}

				if (!href) {
					this.linkEl.hidden = true
					if (this.sepEl) this.sepEl.hidden = true
					return
				}

				this.linkEl.hidden = false
				this.linkEl.href = href
				this.linkEl.textContent = title
				if (this.sepEl) this.sepEl.hidden = false
			}
		}

		customElements.define('l-pdp-breadcrumb', LTAPdpBreadcrumb)
	}

  } catch(e) { console.error(e); }
})();
})();
